import React from 'react'
import clsx from 'clsx'
import { useInView } from 'react-hook-inview'

import AvatarArea from './AvatarArea'
import ContentArea from './ContentArea'
import QueueSkeletonV2 from '../../../molecules/QueueSkeletonV2'

import { useAppDispatch } from '../../../../hooks/redux'
import { MobileScreen, setMobileScreen } from '../../../../slices/convo'
import { useQueueState } from '../../../../providers/QueueStateProvider'
import { useAgent } from '../../../../providers/AgentProvider'
import { usePresence } from '../../../../hooks/usePresence'
import useStyles from './styles'

const ConversationV2 = ({ i = 0, conversation, related, mobile }) => {
  const dispatch = useAppDispatch()
  const {
    accepted,
    setAccepted,
    handleSelect: handleConvoSelect,
    id: selected
  } = useQueueState()
  const { currentUser } = useAgent()
  const { queryPresence } = usePresence()
  const [inViewRef, inView] = useInView({
    rootMargin: mobile ? '100px' : '130px',
    defaultInView: i <= 10,
    unobserveOnEnter: mobile
  })

  const { users, session, state } = conversation

  const isViewing = session && sessionStorage.getItem('viewing') === session
  const isYours = users?.includes(currentUser()?.id) || isViewing
  const pickedUp = isYours || state === 'REJECTED'

  const classes = useStyles({
    selected: related.some(session => session.session === selected),
    mobile
  })

  //  Callback for when a conversation is selected
  const handleSelect = React.useCallback(() => {
    if (accepted) {
      setAccepted(false)
    }
    handleConvoSelect(conversation.session)
    dispatch(setMobileScreen(MobileScreen.Conversation))
  }, [handleConvoSelect, accepted, setAccepted, conversation.session, dispatch])

  // Updates presence
  React.useEffect(() => {
    if (selected) {
      queryPresence(users)
    }
  }, [selected, users, queryPresence])

  return (
    <div
      ref={inViewRef}
      onClick={handleSelect}
      className={clsx(classes.root, pickedUp ? classes.taken : classes.waiting)}
    >
      {inView ? (
        <>
          <AvatarArea conversation={conversation} />

          <ContentArea conversation={conversation} related={related} />
        </>
      ) : (
        <QueueSkeletonV2 />
      )}
    </div>
  )
}

export default ConversationV2
